<template lang="pug">
  v-row.auth-fill-height(justify="center" align="center")
    v-col(
      cols=12 md=7 lg=5 xl=3
    )
      h2 Войти как

      permissions-wrapper(
        :roles="[$conf.ROLES.organization, $conf.ROLES.operator]"
      )
        v-list
          v-list-item.sdo-shadow(
            @click="continueAsCurrentUser"
          )
            permissions-wrapper(:roles="[$conf.ROLES.organization]")
              v-list-item-content
                v-list-item-title Продолжить как организация
                v-list-item-subtitle {{ $user.data.name }}
            permissions-wrapper(:roles="[$conf.ROLES.operator]")
              v-list-item-content
                v-list-item-title Продолжить как оператор
                v-list-item-subtitle {{ $user.data.name }}
            v-list-item-icon
              v-icon mdi-chevron-right

      v-expand-transition
        div(v-if="relatedUsers.length")
          .title.mt-6 Слушатели
          v-list
            v-list-item(
              v-if="!relatedUsers.length"
            )
              v-list-item-content
                v-list-item-subtitle Пользователи не добавлены...

            v-list-item.sdo-shadow.my-2(
              v-for="user in relatedUsers"
              :key="user.id"
              @click="authorize(user)"
            )
              v-list-item-content
                v-list-item-title
                  | {{ user.information_surname }}
                  | {{ user.information_first_name }}
                  | {{ user.information_patronymic }}
                v-list-item-subtitle {{ user.name }}
              v-list-item-icon
                v-icon mdi-chevron-right

      .mt-3: v-btn(
        color="secondary"
        rounded
        block
        text
        @click="addUser"
      )
        .text-h5 +
        span.ml-3 Добавить слушателя
</template>

<script>
import ListenerForm from '@/components/Forms/UsersListenerForm.vue';

export default {
  components: {
    ListenerForm,
  },
  data() {
    return {
      relatedUsers: [],
      loading: {
        relatedUsers: false,
        login: false,
      },
    };
  },
  created() {
    this.fetchUsers();
  },
  methods: {
    fetchUsers() {
      this.loading.relatedUsers = true;
      this.$rHandler(
        this.$api.users.relatedUsers(),
        (resp) => { this.relatedUsers = resp.data.data; },
      );
      this.loading.relatedUsers = false;
    },
    async authorize(user) {
      this.$loader.start();
      const resp = await this.$api.users.authRelatedUser(user.id);
      if (resp.data.access_token) {
        await this.$store.dispatch('auth/INIT_USER', {
          accessToken: resp.data.access_token,
          refreshToken: resp.data.refresh_token,
        });
        const redirectRoute = this.$route.query.redirect ? { path: this.$route.query.redirect } : { name: 'Desktop' };
        this.$router.push(redirectRoute);
      }
      this.$loader.stop();
    },
    continueAsCurrentUser() {
      const redirectRoute = { path: this.$route.query.redirect } || { name: 'Desktop' };
      this.$store.dispatch('auth/SET_AUTHORIZATION', true);
      this.$router.push(redirectRoute);
    },
    addUser() {
      this.$modals.show('generic-controller', {
        title: 'Создать слушателя',
        component: ListenerForm,
        'component-props': {
          successCallback: (resp) => {
            this.relatedUsers.push(resp.data.data);
            this.$modals.close();
          },
        },
      });
    },
  },
};
</script>
